import React, { FC, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { TableInfo } from '@/services/table/tableTypes';
import ROUTES from '@/routers/Routes';
import { replacePathParams } from '@/common/utils/utils';
import TableStatus from '@/components/TableStatus/TableStatus';

import TableStakeInfoSimple from './TableStakeInfoSimple';

interface TableCardSimpleProps {
  table: TableInfo;
  setShowTableInfo: (value: boolean) => void;
  setSelectedRow: (value: TableInfo) => void;
  statusPadding?: boolean;
}

const TableCardSimple: FC<TableCardSimpleProps> = ({
  table,
  setShowTableInfo,
  setSelectedRow,
  statusPadding = true,
}) => {
  const navigate = useNavigate();

  const onClickCardHandler = () => navigate(replacePathParams(ROUTES.TABLE, { tableId: table.id || '' }));

  const onInfoIconClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowTableInfo(true);
    setSelectedRow(table);
  };

  const activePlayerCount = useMemo(
    () => table.seats.reduce((acc, seat) => acc + (seat?.active ? 1 : 0), 0),
    [table.seats],
  );

  return (
    <div
      className="left-4 flex w-full justify-between gap-2 rounded-xl border border-ph-white-1 bg-ph-white-3 py-1.5 pl-3 pr-4 hover:cursor-pointer"
      onClick={onClickCardHandler}
    >
      <TableStatus
        playerCount={table?.players}
        activePlayerCount={activePlayerCount}
        maxPlayers={table?.maxPlayers}
        tableName={table?.name}
        tableGame={table?.game}
        padding={statusPadding}
        onInfoIconClick={onInfoIconClick}
        variantsCount={table.variants.length}
      />
      <TableStakeInfoSimple
        fontSize="text-sm"
        ante={table.ante}
        smallBet={table.smallBet}
        bigBet={table.bigBet}
        smallBlind={table.smallBlind}
        bigBlind={table.bigBlind}
      />
    </div>
  );
};

export default TableCardSimple;
